import React from 'react';
import { Box, Card, CardContent } from '@mui/material';
import Skeleton from './Skeleton';

/**
 * TherapistCardSkeleton - Loading placeholder for TherapistCard component
 * 
 * Matches the layout of premium TherapistCard:
 * - Avatar (80x80 circle)
 * - Name (text line)
 * - Rating stars (small rectangles)
 * - Specialty tags (3 chips)
 * - Additional info (languages, price)
 * - Action buttons (2 rectangles)
 * 
 * Use this when loading therapist list pages
 * 
 * @version 1.0.0 (Feb 2026)
 */

const TherapistCardSkeleton = () => {
  return (
    <Card
      sx={{
        borderRadius: '12px',
        border: '1px solid',
        borderColor: 'grey.200',
        mb: 2,
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box display="flex" gap={2}>
          {/* Avatar */}
          <Skeleton
            variant="circular"
            width={80}
            height={80}
            animation="wave"
          />

          {/* Content */}
          <Box flex={1}>
            {/* Name */}
            <Skeleton
              variant="text"
              width="60%"
              height={28}
              animation="wave"
              sx={{ mb: 1 }}
            />

            {/* Rating */}
            <Box display="flex" gap={0.5} mb={1}>
              {[...Array(5)].map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rectangular"
                  width={16}
                  height={16}
                  animation="wave"
                />
              ))}
              <Skeleton
                variant="text"
                width={40}
                height={16}
                animation="wave"
                sx={{ ml: 1 }}
              />
            </Box>

            {/* Specialty tags */}
            <Box display="flex" gap={1} mb={2}>
              {[...Array(3)].map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rectangular"
                  width={80}
                  height={28}
                  animation="wave"
                  sx={{ borderRadius: '16px' }}
                />
              ))}
            </Box>

            {/* Additional info */}
            <Skeleton
              variant="text"
              width="40%"
              height={16}
              animation="wave"
              sx={{ mb: 0.5 }}
            />
            <Skeleton
              variant="text"
              width="30%"
              height={16}
              animation="wave"
              sx={{ mb: 2 }}
            />

            {/* Action buttons */}
            <Box display="flex" gap={1}>
              <Skeleton
                variant="rectangular"
                width={140}
                height={36}
                animation="wave"
                sx={{ borderRadius: '8px' }}
              />
              <Skeleton
                variant="rectangular"
                width={80}
                height={36}
                animation="wave"
                sx={{ borderRadius: '8px' }}
              />
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TherapistCardSkeleton;
